import { render, staticRenderFns } from "./seckill_3.vue?vue&type=template&id=223cd1ae&scoped=true&"
import script from "./seckill_3.vue?vue&type=script&lang=js&"
export * from "./seckill_3.vue?vue&type=script&lang=js&"
import style0 from "./seckill_3.vue?vue&type=style&index=0&id=223cd1ae&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223cd1ae",
  null
  
)

export default component.exports